var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "mask",
      on: {
        click: function ($event) {
          if ($event.target !== $event.currentTarget) return null
          return _vm.onClickCancel.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "div",
        {
          ref: "dialogRoot",
          staticClass: "dialog",
          attrs: {
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": _vm.titleId,
            tabindex: "-1",
          },
        },
        [
          _c("header", { staticClass: "dialog__header" }, [
            _c(
              "button",
              {
                staticClass: "dialog__edit",
                attrs: { type: "button" },
                on: { click: _vm.onClickEdit },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("proofreadingProperNounExcludeDialog.edit")) +
                    " "
                ),
              ]
            ),
            _c(
              "h2",
              { staticClass: "dialog__title", attrs: { id: _vm.titleId } },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t("proofreadingProperNounExcludeDialog.title")
                    ) +
                    " "
                ),
              ]
            ),
            _c(
              "button",
              {
                staticClass: "dialog__close",
                attrs: {
                  type: "button",
                  "aria-label": _vm.$t(
                    "proofreadingProperNounExcludeDialog.close"
                  ),
                },
                on: { click: _vm.onClickCancel },
              },
              [_vm._v(" × ")]
            ),
          ]),
          _c(
            "div",
            { staticClass: "dialog__body" },
            [
              _vm.isLoading
                ? _c("div", { staticClass: "dialog__loading" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("proofreadingProperNounExcludeDialog.loading")
                        ) +
                        " "
                    ),
                  ])
                : [
                    _c(
                      "button",
                      {
                        staticClass: "row row--select-all",
                        attrs: { type: "button" },
                        on: { click: _vm.onToggleSelectAll },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "select-all-box",
                            attrs: { "data-checked": _vm.isAllSelected },
                          },
                          [
                            _c("CheckboxIcon", {
                              attrs: {
                                "is-checked": _vm.isAllSelected,
                                fill: _vm.checkboxFill(_vm.isAllSelected),
                              },
                            }),
                          ],
                          1
                        ),
                        _c("span", { staticClass: "label" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "proofreadingProperNounExcludeDialog.selectAll"
                              )
                            )
                          ),
                        ]),
                      ]
                    ),
                    _vm.properNouns.length === 0
                      ? _c("p", { staticClass: "dialog__empty" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "proofreadingProperNounExcludeDialog.empty"
                                )
                              ) +
                              " "
                          ),
                        ])
                      : _c(
                          "ul",
                          { staticClass: "noun-list" },
                          _vm._l(_vm.properNouns, function (noun) {
                            return _c(
                              "li",
                              {
                                key: noun.properNounId,
                                staticClass: "row row--noun",
                                on: {
                                  click: function ($event) {
                                    return _vm.onToggleNoun(noun.properNounId)
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "switch",
                                    attrs: {
                                      role: "switch",
                                      "aria-checked": _vm.isSelected(
                                        noun.properNounId
                                      ),
                                      "data-on": _vm.isSelected(
                                        noun.properNounId
                                      ),
                                    },
                                  },
                                  [_c("span", { staticClass: "switch__knob" })]
                                ),
                                _c("span", { staticClass: "label" }, [
                                  _vm._v(_vm._s(noun.name)),
                                ]),
                              ]
                            )
                          }),
                          0
                        ),
                  ],
            ],
            2
          ),
          _c("footer", { staticClass: "dialog__footer" }, [
            _c(
              "button",
              {
                staticClass: "button button--primary",
                attrs: { type: "button" },
                on: { click: _vm.onClickConfirm },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t("proofreadingProperNounExcludeDialog.confirm")
                    ) +
                    " "
                ),
              ]
            ),
            _c(
              "button",
              {
                staticClass: "button button--secondary",
                attrs: { type: "button" },
                on: { click: _vm.onClickCancel },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t("proofreadingProperNounExcludeDialog.cancel")
                    ) +
                    " "
                ),
              ]
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }